import React, { useState, useEffect } from "react";
import ReactStars from "react-rating-stars-component";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import { Colxx } from "../../../components/common/CustomBootstrap";
import "react-treeview/react-treeview.css";
import { JobService } from "../../../services/JobService";
import {
  Row,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Form,
  FormGroup,
} from "reactstrap";

const LanguagesList = (props) => {
  const {parentCallback,deletedList}=props
  const [check,setChecked]=useState(false)
  const [modalRight, setModalRight] = useState(false);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [searchLanguages,setSearchLanguages]=useState([])
  const [languageshow, setlanguageShow] = useState(true);
  const [categories, setCategories] = useState([]);
  const [show, setShow] = useState([]);
  const [rating, setRating] = useState(0);
  const [selectedSoftSkills, setSelectedSoftSkills] = useState([]);
  const [scategories, setSCategories] = useState([]);
  const [buttonShow, setButtonShow] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [writtenSelectedSkills, setWrittenSelectedSkills] = useState([]);
  const [pageSize, setPageSize] = useState(110);
  const [selectedSpokenId, setSelectedSpokenId] = useState([]);
  const [selectedWrittenId, setSelectedWrittenId] = useState([]);
  const [languageid, setlanguageid] = useState("");
  const [languagename, setlanguagename] = useState("");
  const [sortOrder, setSortOrder] = useState("ASC");
  const [languageLevels, setLanguageLevels] = useState([]);
  const [jobStatus, setJobStatus] = useState("");
  const [ratingSpokenSelectedList, setRatingSpokenSelectedList] = useState([]);
  const [ratingWriteSelectedList, setRatingWriteSelectedList] = useState([]);
  const [newList, setNewList] = useState([])
  
  useEffect(()=>{
    setNewList(deletedList)
 },[deletedList])

 const handleCheck = (event, Skills) => {
 
  if (event.target.checked) {
   if (newList.length>0){
      if ([...newList].includes(Skills)===false){
        setNewList([...newList,Skills])
      }
   }
   else{
    setNewList([...newList,Skills])
   }
      
  } 
  else if (event.target.checked===false) {
    
    setNewList(newList.filter(item=>item.id!==Skills.id))
  }
 
};

  useEffect(() => { 
    getLanguagesList();
  }, []);

  const getLanguagesList = () => {
    JobService.getLanguageService(pageSize, sortOrder).then((response) => {
     
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          var languageDetails = response.data;
        

          if (languageDetails != null) {
            setCategories(languageDetails.skills);
            setFilteredCategories(languageDetails.skills);
            setSearchLanguages(languageDetails.skills)

            
          }
        }
      } catch (err) {}
    });
  };

  const saveReqLanguages = () => {
    parentCallback(newList);
    setFilteredCategories(searchLanguages);
    setModalRight(false)  
  };
  
  const onCancleLanguageSearch=()=>{
    setModalRight(false);
    setFilteredCategories(searchLanguages)
  }

  const onAddLanguages = () => {
    setModalRight(true);
    
  };

  const searchItems = (searchValue) => {
    setFilteredCategories(searchLanguages.filter(searchItem=>searchItem.name.toLowerCase().includes(searchValue.toLowerCase())))
  };

  return (
    <div >
      <div className="skill-header">
        <div>
            <Button
              color="primary"
              size="sm"
              className='btn-sm mt-1 t-button-skill-edu btn '
              outline
              onClick={onAddLanguages}
            >
              + Languages
            </Button>
           
        </div>
      </div>

      <div>
        <Modal
          scrollable={true}
          isOpen={modalRight}
          toggle={() => setModalRight(!modalRight)}
        >
          <ModalHeader className="mdl_header">
            <div>
              <strong>Select languages</strong>
            </div>
          </ModalHeader>
          <ModalBody className="labelSize">
            <div className="col-lg-12 p-0">
              <Input
                type="search"
                id="search"
                icon="search"
                placeholder="Search for languages"
                onChange={(e) => searchItems(e.target.value)}
              />
            </div>
            {languageshow &&
              filteredCategories.length > 0 &&
              filteredCategories.map((skill, index) => {
                return (
                  <div key={index}>       
                  {/* {show.indexOf(skill)===-1 &&  */}
                   <div className="col-12" key={skill.id}>
                  <div className="col-12">
                    <div className="col-12">
                      <div className="row">
                        <div className="col-sm-6 mt-2">
                          <label className="row">
                            <input
                              id="skillId"
                              type="checkbox"
                              className="input_skill"
                             
                              onChange={(e) =>
                                handleCheck(e, skill)
                              }
                            />
                            <div className="terms">{skill.description} </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* } */}
                  </div>          
                );
              })}

          </ModalBody>
          <ModalFooter className="p-4">
            <Button
              color="primary"
              size="sm"
              outline
              onClick={saveReqLanguages}
            >
              Save
            </Button>{" "}
            <Button
              color="primary"
              size="sm"
              outline
              onClick={onCancleLanguageSearch}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
        
      
    </div>
  );
};

export default LanguagesList;